import lozad from 'lozad';
import Splide from '@splidejs/splide';
import CONFIG from '@js/config/splideConfig';
import { CustomPagination } from '@js/components/splide/extensions/CustomPagination';
import { CustomProgress } from '@js/components/splide/extensions/CustomProgress';

// Srcsety ukrytych slajdow karuzeli kafelka budujemy dopiero przy inicie,
// zamiast wysylac je w HTML (ok. 150 KB na listingu). Format identyczny
// z imgix_srcset: "{url}&dpr=1 1x, {url}&dpr=2 2x, ..."; liczba wariantow
// jak dprs presetu product-list-item w config/imgix.php.
const PRODUCT_ITEM_LAZY_DPRS = 3;

const buildLazySrcsets = (sliderElement) => {
    sliderElement
        .querySelectorAll('img[data-splide-lazy]:not([data-splide-lazy-srcset])')
        .forEach((img) => {
            const base = img.dataset.splideLazy;

            if (!base || !base.includes('?')) return;

            const sources = [];

            for (let dpr = 1; dpr <= PRODUCT_ITEM_LAZY_DPRS; dpr += 1) {
                sources.push(`${base}&dpr=${dpr} ${dpr}x`);
            }

            img.dataset.splideLazySrcset = sources.join(', ');
        });
};

const observer = lozad(
    '.js-splide:not([data-manual-init="true"]):not([data-instant-init="true"])',
    {
        load: (sliderElement) => {
            const config = CONFIG[sliderElement.dataset.config] || CONFIG.default;

            if (sliderElement.dataset.config === 'productItemCarousel') {
                buildLazySrcsets(sliderElement);
            }

            sliderElement.splide = new Splide(sliderElement, config);

            sliderElement.splide.mount({ CustomPagination, CustomProgress });

            window.dispatchEvent(
                new CustomEvent('sliderInitialized', {
                    detail: { sliderElement },
                })
            );

            const paginationElement = sliderElement.querySelector('.splide__pagination');

            if (paginationElement) {
                paginationElement.addEventListener('click', (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                });
            }
        },
    }
);

['DOMContentLoaded', 'RemoteContentLoaded', 'livewire.component.rendered'].forEach((event) =>
    window.addEventListener(event, () => observer.observe())
);
export default function initSplideObserver() {
    observer.observe();
}
